import React from "react";
import { BrandTableLoadingMark } from "@/components/branding/BrandTableLoadingMark.jsx";

/**
 * Outlet fallback while a lazy page chunk loads. MainLayout chrome stays up;
 * header chrome of the table remains visible, overlay sits on the body only.
 */
export function PageSkeleton() {
    return (
        <div className="relative min-h-[min(32rem,calc(100dvh-12rem))] w-full overflow-hidden rounded-[var(--ds-radius-surface)] border border-border bg-card">
            <div className="border-b border-border px-4 py-3">
                <div className="h-4 w-40 rounded-[var(--ds-radius-control-compact)] bg-muted/50" />
            </div>
            <div className="relative">
                <div className="divide-y divide-border">
                    {Array.from({ length: 8 }, (_, i) => (
                        <div key={i} className="h-11 bg-card" />
                    ))}
                </div>
                <div
                    data-slot="table-loading"
                    className="absolute inset-0 z-10 flex items-center justify-center bg-card/80 backdrop-blur-[1px]"
                    role="status"
                    aria-live="polite"
                    aria-busy="true"
                >
                    <BrandTableLoadingMark />
                </div>
            </div>
        </div>
    );
}
